module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/232-yemen-ef4533c42da87a345aa4c6e9443cfb68.svg";